import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';

export type IconVariant = 'DEFAULT' | 'INDIGO' | 'ORANGE';

const VARIANT_CLASS_BY_TYPE: Record<IconVariant, string> = {
  DEFAULT: '',
  INDIGO: 'icon--indigo',
  ORANGE: 'icon--orange',
};

@Component({
  selector: 'app-icon',
  imports: [NgOptimizedImage],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.width.px]': 'resolvedWidth()',
    '[style.height.px]': 'resolvedHeight()',
    '[class]': 'variantClass()',
  },
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
})
export class IconComponent {
  src = input.required<string>();
  size = input(24);
  width = input<number>();
  height = input<number>();
  alt = input('');
  colorable = input(false);
  variant = input<IconVariant>('DEFAULT');

  protected resolvedWidth = computed(() => this.width() ?? this.size());
  protected resolvedHeight = computed(() => this.height() ?? this.size());
  protected maskImageUrl = computed(() => `url('/${this.src()}')`);
  protected variantClass = computed(() => VARIANT_CLASS_BY_TYPE[this.variant()]);
}
